import { Callout, H3, Intent } from '@blueprintjs/core';
import * as React from 'react';

import { Dropzone } from 'src/components/Dropzone';
import { FileExtension } from 'src/constants/fileExtensions';
import * as copy from 'src/templates/copy';

type FileUploadTileProps = {
  handleDroppedFiles: (files: File[]) => void;
};

export const FileUploadTile: React.VFC<FileUploadTileProps> = ({
  handleDroppedFiles,
}) => {
  return (
    <Callout className="sd-resource-type-panel__tile" intent={Intent.NONE}>
      <H3>
        {copy.components.projectResourceDialog.resourceTypePanel.dropzone.title}
      </H3>
      <Dropzone
        acceptTypes={[FileExtension.CSV]}
        buttonProps={{
          text: copy.components.projectResourceDialog.resourceTypePanel.dropzone
            .button,
          large: true,
          intent: Intent.PRIMARY,
        }}
        onDropAccepted={handleDroppedFiles}
        text={
          copy.components.projectResourceDialog.resourceTypePanel.dropzone.drag
        }
      />
    </Callout>
  );
};
